const staffs = {
  permissionSource: 'api::staff.staff',
  creationTitle: 'Create Staff',
  creationEndPoint: '/staffs',
  detailTitle: 'Staff: :title',
  detailEndPoint:
    '/staffs/:id?populate[0]=photo&populate[1]=department&populate[2]=position&populate[3]=personal_info&populate[4]=personal_info.tel&populate[5]=personal_info.fax&populate[6]=personal_info.address&populate[7]=personal_info.address.region&populate[8]=user&populate[9]=employment_contracts&populate[10]=sales_quotations&populate[11]=sales_invoices&populate[12]=sales_receipts&populate[13]=purchase_orders&populate[14]=business_entity',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Code',
              value: 'code',
              tag: 'input',
              type: 'text',
              placeholder: 'Staff Code',
              required: true,
            },
            {
              label: 'Name',
              value: 'name',
              tag: 'input',
              type: 'text',
              placeholder: 'Staff Name',
              required: true,
            },
            {
              label: 'Email',
              value: 'personal_info.email',
              tag: 'input',
              type: 'email',
            },
            {
              isLayout: true,
              layoutPattern: '1-1-2',
              children: [
                {
                  label: 'Telephone',
                  value: 'personal_info.tel.country_code',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'personal_info.tel.area_code',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'personal_info.tel.contact_number',
                  tag: 'input',
                  type: 'number',
                },
              ],
            },
          ],
        },
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Photo',
              value: 'photo',
              tag: 'media',
              acceptFile: 'image/*',
            },
          ],
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              isLayout: true,
              layoutPattern: '1-1-2',
              children: [
                {
                  label: 'Fax',
                  value: 'personal_info.fax.country_code',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'personal_info.fax.area_code',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'personal_info.fax.contact_number',
                  tag: 'input',
                  type: 'number',
                },
              ],
            },
            {
              label: 'Active Staff',
              value: 'active',
              tag: 'switch',
            },
            {
              label: 'The Staff is employee from the business entity',
              value: 'is_employee',
              tag: 'switch',
            },
            {
              label: 'Business Entity',
              value: 'business_entity',
              tag: 'single-select',
              dataSourceUrl: '/business-entities',
              dataLabel: 'title',
              required: true,
            },
            {
              label: 'Department',
              value: 'department',
              tag: 'single-select',
              dataSourceUrl:
                '/departments?filters[business_entity][id][$eq]=:active_business_entity',
              dataLabel: 'title',
              required: true,
            },
            {
              label: 'Position',
              value: 'position',
              tag: 'single-select',
              dataSourceUrl: '/positions',
              dataLabel: 'title',
              required: true,
            },
            {
              label: 'Gender',
              value: 'gender',
              tag: 'single-enum-select',
              dataSourceUrl: '/content-type-builder/content-types/api::staff.staff',
              dataLabel: 'gender',
            },
            {
              label: 'Date of Birth',
              value: 'date_of_birth',
              tag: 'date-picker',
            },
          ],
        },
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'User',
              value: 'user',
              tag: 'single-select',
              dataSourceUrl: '/users',
              dataLabel: 'username',
            },
            {
              label: 'Facebook ID',
              value: 'personal_info.facebook_id',
              tag: 'input',
              type: 'text',
            },
            {
              label: 'Google+ ID',
              value: 'personal_info.google_plus_id',
              tag: 'input',
              type: 'text',
            },
            {
              label: 'Twitter ID',
              value: 'personal_info.twitter_id',
              tag: 'input',
              type: 'text',
            },
            {
              label: 'Skype ID',
              value: 'personal_info.skype_id',
              tag: 'input',
              type: 'text',
            },
            {
              label: 'QQ ID',
              value: 'personal_info.qq_id',
              tag: 'input',
              type: 'text',
            },
            {
              label: 'WeChat ID',
              value: 'personal_info.wechat_id',
              tag: 'input',
              type: 'text',
            },
            {
              label: 'HKID',
              value: 'personal_info.HKID',
              tag: 'input',
              type: 'text',
            },
          ],
        },
      ],
    },
    {
      label: 'Address',
      value: 'personal_info.address.address_line_1',
      placeholder: 'Address Line 1',
      tag: 'input',
      type: 'text',
    },
    {
      value: 'personal_info.address.address_line_2',
      placeholder: 'Address Line 2',
      tag: 'input',
      type: 'text',
    },
    {
      value: 'personal_info.address.address_line_3',
      placeholder: 'Address Line 3',
      tag: 'input',
      type: 'text',
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Country',
          value: 'personal_info.address.country',
          tag: 'input',
          type: 'text',
        },
        {
          label: 'Region',
          value: 'personal_info.address.region',
          tag: 'single-select',
          dataSourceUrl: '/regions',
          dataLabel: 'name',
        },
        {
          label: 'Zip',
          value: 'personal_info.address.zip',
          tag: 'input',
          type: 'text',
        },
      ],
    },
    {
      label: 'Employment Contracts',
      value: 'employment_contracts',
      tag: 'multi-media',
      acceptFile: '*',
    },
    {
      label: 'Sales Quotations',
      value: 'sales_quotations',
      tag: 'static-multi-select',
      redirectRoute: '/sales-quotations/:id',
      dataLabel: 'code',
    },
    {
      label: 'Sales Invoices',
      value: 'sales_invoices',
      tag: 'static-multi-select',
      redirectRoute: '/sales-invoices/:id',
      dataLabel: 'code',
    },
    {
      label: 'Sales Receipts',
      value: 'sales_receipts',
      tag: 'static-multi-select',
      redirectRoute: '/sales-receipts/:id',
      dataLabel: 'code',
    },
    {
      label: 'Purchase Orders',
      value: 'purchase_orders',
      tag: 'static-multi-select',
      redirectRoute: '/purchase-orders/:id',
      dataLabel: 'code',
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
  creationData: {
    business_entity: ':active_business_entity',
  },
}
export default staffs
